import { render } from "./DisplaySpecials.vue?vue&type=template&id=207abb6e&scoped=true"
import script from "./DisplaySpecials.vue?vue&type=script&lang=js"
export * from "./DisplaySpecials.vue?vue&type=script&lang=js"

import "./DisplaySpecials.vue?vue&type=style&index=0&id=207abb6e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-207abb6e"

export default script